import React from "react";
import { Box } from "@chakra-ui/react";
import { DecorativeBackgroundImage } from "components/images";
import diamondGradient from "../../../../../public/assets/platform/composable-cdp/diamond-gradient.png";

function Aura({ id }: { id: string }) {
  return (
    <Box
      id={id}
      boxShadow="xl"
      boxSize={{ base: "180px", xl: "200px" }}
      pos="absolute"
      left="50%"
      right="50%"
      top="50%"
      bottom="50%"
      transform="translateY(-50%)"
      opacity={0}
    >
      <DecorativeBackgroundImage priority src={diamondGradient} />
    </Box>
  );
}

export function AuraAnimation() {
  return (
    <Box pos="absolute" inset={0}>
      <Box pos="absolute" inset={0} right="-36%">
        <Aura id="aura-4" />
        <Aura id="aura-3" />
        <Aura id="aura-2" />
        <Aura id="aura-1" />
      </Box>

      <Box pos="absolute" bgGradient="linear(to-b, new.green.950 8%, transparent)" top={0} right={0} w="100%" h="60%" />
      <Box
        pos="absolute"
        bgGradient="linear(to-t, new.green.950 8%, transparent)"
        bottom={0}
        right={0}
        w="100%"
        h="60%"
      />
    </Box>
  );
}
